(function () {

    window.laroute = (function () {

        var routes = {

            absolute: false,
            rootUrl: 'http://djpromo.pl.test/',
            routes : [{"host":null,"methods":["GET","HEAD"],"uri":"a\/single\/{guid}","name":"public::singles::ajax::open_single","action":"App\FrontEnd\Controllers\SinglesController@singleAjax"},{"host":null,"methods":["GET","HEAD"],"uri":"a\/track\/buy\/{guid}","name":"public::singles::ajax::buy_track","action":"App\FrontEnd\Controllers\TracksController@buyAjax"},{"host":null,"methods":["POST"],"uri":"a\/track\/buy\/{guid}","name":"public::singles::ajax::buy_track","action":"App\FrontEnd\Controllers\TracksController@buyAjaxPost"},{"host":null,"methods":["POST"],"uri":"a\/cart\/add\/{guid}","name":"public::cart::ajax::add","action":"App\FrontEnd\Controllers\CartController@addAjaxPost"},{"host":null,"methods":["POST"],"uri":"a\/cart\/remove\/{guid}","name":"public::cart::ajax::remove","action":"App\FrontEnd\Controllers\CartController@removeAjaxPost"},{"host":null,"methods":["GET","HEAD"],"uri":"konto\/digitalcd\/a\/dcd\/d\/{auth}\/{cd?}","name":"public::account::promosets::ajax::download","action":"App\FrontEnd\Controllers\PromoSets\PromoSetsController@ajaxDownload"},{"host":null,"methods":["GET","HEAD"],"uri":"konto\/digitalcd\/a\/dcd\/i\/{auth}\/{cd?}","name":"public::account::promosets::ajax::info","action":"App\FrontEnd\Controllers\PromoSets\PromoSetsController@ajaxInfo"},{"host":null,"methods":["GET","HEAD"],"uri":"konto\/digitalcd\/a\/dcd\/c\/{auth}\/{cd?}","name":"public::account::promosets::ajax::certificates","action":"App\FrontEnd\Controllers\PromoSets\PromoSetsController@ajaxCertificates"},{"host":null,"methods":["GET","HEAD"],"uri":"a\/buy-list\/{guid}","name":"public::lists::ajax::buy_list","action":"App\FrontEnd\Controllers\TrackListsController@buyAjax"},{"host":null,"methods":["POST"],"uri":"a\/buy-list\/{guid}","name":"public::lists::ajax::buy_list","action":"App\FrontEnd\Controllers\TrackListsController@buyAjaxPost"},{"host":null,"methods":["GET","HEAD"],"uri":"a\/propose\/{guid}","name":"public::propositions::ajax::get_lists","action":"App\FrontEnd\Controllers\ProposeController@getList"},{"host":null,"methods":["POST"],"uri":"a\/propose\/{guid}","name":"public::propositions::ajax::propose","action":"App\FrontEnd\Controllers\ProposeController@postPropose"},{"host":null,"methods":["DELETE"],"uri":"a\/propose\/{guid}","name":"public::propositions::ajax::remove_propose","action":"App\FrontEnd\Controllers\ProposeController@deletePropose"},{"host":null,"methods":["GET","HEAD"],"uri":"a\/propose\/{guid}\/search_track","name":"public::propositions::ajax::search_track","action":"\App\Http\Controllers\AdminPages\Lists\TrackListsController@search_track"},{"host":null,"methods":["GET","HEAD"],"uri":"administrator\/promocd\/cd\/{guid}","name":"admin::promosets::cd.view","action":"App\Admin\Controllers\PromoSets\PromoSetsController@getCD"},{"host":null,"methods":["POST"],"uri":"administrator\/promocd\/set\/{guid}","name":"admin::promosets::ajax::cd.create","action":"App\Admin\Controllers\PromoSets\PromoSetsController@createCd"},{"host":null,"methods":["GET","HEAD"],"uri":"administrator\/promocd\/cd\/{guid}\/search_track","name":"admin::promosets::ajax::cd.search_track","action":"App\Admin\Controllers\PromoSets\PromoSetsController@search_track"},{"host":null,"methods":["GET","HEAD"],"uri":"administrator\/files_processing\/a\/search_single","name":"admin::files_processing::ajax::new.search_track","action":"App\Admin\Controllers\ImportTasks\CreateImportTasksController@getSearchSingle"},{"host":null,"methods":["GET","HEAD"],"uri":"administrator\/przesylki\/{shipping_id}","name":"admin::shipping_packages::package","action":"App\Admin\Controllers\ShippingPackages\ShippingPackagesController@getPackage"},{"host":null,"methods":["GET","HEAD"],"uri":"administrator\/kody\/list\/{batch_id}","name":"admin::vouchers::list_batch_id","action":"App\Admin\Controllers\Vouchers\VouchersController@getBatchIdList"},{"host":null,"methods":["GET","HEAD"],"uri":"administrator\/kody\/generuj","name":"admin::vouchers::generate_special","action":"App\Admin\Controllers\Vouchers\VouchersGenerationController@getGenerateSpecial"},{"host":null,"methods":["GET","HEAD"],"uri":"administrator\/kody\/generuj\/{shipping_id}","name":"admin::vouchers::generate","action":"App\Admin\Controllers\Vouchers\VouchersGenerationController@getGenerate"},{"host":null,"methods":["GET","HEAD"],"uri":"administrator\/lists\/edytuj\/{guid}\/search_track","name":"admin::lists::ajax::list.search_track","action":"App\Admin\Controllers\Lists\TrackListsController@search_track"},{"host":null,"methods":["GET","HEAD"],"uri":"administrator\/newsletters\/edytuj\/{guid}\/search_track","name":"admin::newsletters::ajax::search_track","action":"App\Admin\Controllers\Newsletters\NewslettersController@search_track"},{"host":null,"methods":["POST"],"uri":"a\/notification\/{id}","name":"public::notifications::ajax::mark_as_read","action":"Closure"},{"host":null,"methods":["POST"],"uri":"a\/feedback","name":"public::feedback::ajax::send","action":"Closure"}],
            prefix: '',

            route : function (name, parameters, route) {
                route = route || this.getByName(name);

                if ( ! route ) {
                    return undefined;
                }

                return this.toRoute(route, parameters);
            },

            url: function (url, parameters) {
                parameters = parameters || [];

                var uri = url + '/' + parameters.join('/');

                return this.getCorrectUrl(uri);
            },

            toRoute : function (route, parameters) {
                var uri = this.replaceNamedParameters(route.uri, parameters);
                var qs  = this.getRouteQueryString(parameters);

                if (this.absolute && this.isOtherHost(route)){
                    return "//" + route.host + "/" + uri + qs;
                }

                return this.getCorrectUrl(uri + qs);
            },

            isOtherHost: function (route){
                return route.host && route.host != window.location.hostname;
            },

            replaceNamedParameters : function (uri, parameters) {
                uri = uri.replace(/\{(.*?)\??\}/g, function(match, key) {
                    if (parameters.hasOwnProperty(key)) {
                        var value = parameters[key];
                        delete parameters[key];
                        return value;
                    } else {
                        return match;
                    }
                });

                // Strip out any optional parameters that were not given
                uri = uri.replace(/\/\{.*?\?\}/g, '');

                return uri;
            },

            getRouteQueryString : function (parameters) {
                var qs = [];
                for (var key in parameters) {
                    if (parameters.hasOwnProperty(key)) {
                        qs.push(key + '=' + parameters[key]);
                    }
                }

                if (qs.length < 1) {
                    return '';
                }

                return '?' + qs.join('&');
            },

            getByName : function (name) {
                for (var key in this.routes) {
                    if (this.routes.hasOwnProperty(key) && this.routes[key].name === name) {
                        return this.routes[key];
                    }
                }
            },

            getByAction : function(action) {
                for (var key in this.routes) {
                    if (this.routes.hasOwnProperty(key) && this.routes[key].action === action) {
                        return this.routes[key];
                    }
                }
            },

            getCorrectUrl: function (uri) {
                var url = this.prefix + '/' + uri.replace(/^\/?/, '');

                if ( ! this.absolute) {
                    return url;
                }

                return this.rootUrl.replace('/\/?$/', '') + url;
            }
        };

        var getLinkAttributes = function(attributes) {
            if ( ! attributes) {
                return '';
            }

            var attrs = [];
            for (var key in attributes) {
                if (attributes.hasOwnProperty(key)) {
                    attrs.push(key + '="' + attributes[key] + '"');
                }
            }

            return attrs.join(' ');
        };

        var getHtmlLink = function (url, title, attributes) {
            title      = title || url;
            attributes = getLinkAttributes(attributes);

            return '<a href="' + url + '" ' + attributes + '>' + title + '</a>';
        };

        return {
            // Generate a url for a given controller action.
            // laroute.action('HomeController@getIndex', [params = {}])
            action : function (name, parameters) {
                parameters = parameters || {};

                return routes.route(name, parameters, routes.getByAction(name));
            },

            // Generate a url for a given named route.
            // laroute.route('routeName', [params = {}])
            route : function (route, parameters) {
                parameters = parameters || {};

                return routes.route(route, parameters);
            },

            // Generate a fully qualified URL to the given path.
            // laroute.route('url', [params = {}])
            url : function (route, parameters) {
                parameters = parameters || {};

                return routes.url(route, parameters);
            },

            // Generate a html link to the given url.
            // laroute.link_to('foo/bar', [title = url], [attributes = {}])
            link_to : function (url, title, attributes) {
                url = this.url(url);

                return getHtmlLink(url, title, attributes);
            },

            // Generate a html link to the given route.
            // laroute.link_to_route('route.name', [title=url], [parameters = {}], [attributes = {}])
            link_to_route : function (route, title, parameters, attributes) {
                var url = this.route(route, parameters);

                return getHtmlLink(url, title, attributes);
            },

            // Generate a html link to the given controller action.
            // laroute.link_to_action('HomeController@getIndex', [title=url], [parameters = {}], [attributes = {}])
            link_to_action : function(action, title, parameters, attributes) {
                var url = this.action(action, parameters);

                return getHtmlLink(url, title, attributes);
            }

        };

    }).call(this);

    /**
     * Expose the class either via AMD, CommonJS or the global object
     */
    if (typeof define === 'function' && define.amd) {
        define(function () {
            return laroute;
        });
    }
    else if (typeof module === 'object' && module.exports){
        module.exports = laroute;
    }
    else {
        window.laroute = laroute;
    }

}).call(this);

